import { useEffect, useState } from "react";
import { Calendar } from "lucide-react";
import { trackContact } from "@/lib/tracking";

export default function StickyCTA({ footer }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const wa = footer?.whatsapp_number;
  const waHref = wa
    ? `https://wa.me/${wa}?text=${encodeURIComponent(footer?.whatsapp_message || "Hi Mostash, I'd love to enquire about wedding planning.")}`
    : null;

  return (
    <>
      {/* Mobile sticky bar */}
      <div
        data-testid="sticky-mobile-cta"
        className={`md:hidden fixed inset-x-0 bottom-0 z-40 transition-transform duration-500 ${visible ? "translate-y-0" : "translate-y-full"}`}
      >
        <div className="bg-ivory/95 backdrop-blur-xl border-t border-beige px-4 py-3 grid grid-cols-2 gap-3 shadow-card">
          {waHref ? (
            <a
              href={waHref}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackContact("whatsapp", { source_section: "sticky_mobile" })}
              data-testid="sticky-mobile-whatsapp"
              className="inline-flex items-center justify-center gap-2 h-12 bg-[#25D366] text-white text-[11px] uppercase tracking-[0.18em] font-medium"
            >
              <WhatsAppIcon className="h-4 w-4" />
              WhatsApp
            </a>
          ) : <span />}
          <a
            href="#contact"
            data-testid="sticky-mobile-book"
            className="inline-flex items-center justify-center gap-2 h-12 bg-teal-600 text-ivory text-[11px] uppercase tracking-[0.18em] font-medium"
          >
            <Calendar className="h-4 w-4" strokeWidth={1.5} />
            Book Consultation
          </a>
        </div>
      </div>

      {/* Desktop floating WhatsApp */}
      {waHref ? (
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackContact("whatsapp", { source_section: "sticky_desktop" })}
          data-testid="sticky-whatsapp"
          aria-label="Chat on WhatsApp"
          className={`hidden md:inline-flex fixed z-40 bottom-6 right-6 h-14 w-14 rounded-full bg-[#25D366] shadow-card items-center justify-center hover:bg-charcoal transition-colors duration-300 ${visible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        >
          <WhatsAppIcon className="h-7 w-7 text-white" />
        </a>
      ) : null}
    </>
  );
}

function WhatsAppIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
      <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.158 0-.353-.087-.474-.158-.946-.491-1.832-1.13-2.6-1.873-.215-.21-.567-.547-.567-.84 0-.396.706-.633.857-1.026.155-.405.105-.91-.078-1.292-.187-.396-.567-1.34-.886-1.682-.27-.29-.62-.27-.945-.27-.27 0-.62.05-.886.236-.945.633-1.395 1.79-1.395 2.92 0 1.65.946 3.21 2.085 4.36 1.395 1.39 3.32 2.34 5.273 2.84.55.14 1.025.24 1.518.24.535 0 1.42-.04 1.84-.385.535-.43.836-1.13.836-1.79 0-.32-.118-.43-.402-.633-.402-.293-.96-.633-1.318-.633zM16.057 4.5c-6.27 0-11.39 5.12-11.39 11.39 0 2.205.626 4.36 1.832 6.207L4.5 27.5l5.605-1.97c1.79 1.07 3.83 1.62 5.952 1.62 6.27 0 11.39-5.12 11.39-11.39 0-3.05-1.18-5.92-3.32-8.07-2.14-2.14-5-3.18-8.07-3.18zm0 20.83c-1.95 0-3.83-.527-5.435-1.49l-.395-.236-3.985 1.39 1.43-3.83-.275-.395c-1.108-1.605-1.685-3.524-1.685-5.473 0-5.473 4.397-9.87 9.87-9.87 2.643 0 5.135 1.026 6.97 2.86 1.835 1.835 2.86 4.327 2.86 6.97 0 5.473-4.4 9.87-9.84 9.87z" />
    </svg>
  );
}
